import { Component } from "@angular/core"
import { Router } from "@angular/router"

@Component({
    selector: "app-filter-clear",
    templateUrl: "./filter-clear.component.html",
    styleUrls: ["./filter-clear.component.less"],
})
export class FilterClearComponent {
    constructor(private router: Router) {}

    public clearFilters() {
        this.router.navigate([], { queryParams: { page: null } })
    }
}
